export function StorageBar({ usedGb, quotaGb, pct }) {
  if (quotaGb == null) return <span style={{ color: 'var(--muted)', fontSize: 12 }}>Sin plan asignado</span>;
  const p     = pct ?? 0;
  const color = p >= 90 ? 'var(--red)' : p >= 85 ? 'var(--yellow)' : 'var(--accent)';
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    fontSize: 12, marginBottom: 6, fontFamily: 'var(--mono)' }}>
        <span style={{ color: 'var(--text)' }}>
          {usedGb.toFixed(1)} GB <span style={{ color: 'var(--muted)' }}>/ {quotaGb} GB</span>
        </span>
        <span style={{ color }}>{p.toFixed(1)}%</span>
      </div>
      <div style={{ height: 6, background: 'var(--border)', borderRadius: 3, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${Math.min(p, 100)}%`,
                      background: color, borderRadius: 3,
                      transition: 'width 0.3s ease' }} />
      </div>
      {p >= 85 && (
        <div style={{ marginTop: 6, fontSize: 11, color, fontFamily: 'var(--mono)' }}>
          {p >= 90 ? '⚠ STORAGE CRÍTICO' : '⚠ Storage alto'}
        </div>
      )}
    </div>
  );
}
